class I18nNumber {
    constructor(value) {
        this.value = value;
        this.currency = I18nNumber.currency;
        this.locale = I18nNumber.locale;
    }

    static locale = 'en-us';

    static currency = 'USD';

    static setLocale(locale) {
        I18nNumber.locale = locale;
    }

    static getLocale(locale) {
        return I18nNumber.locale;
    }

    static setCurrency(currency) {
        I18nNumber.currency = currency;
    }

    static getCurrency(currency) {
        return I18nNumber.currency;
    }

    setLocale(locale) {
        this.locale = locale;
        return this;
    }

    getLocale(locale) {
        return this.locale;
    }

    setCurrency(currency) {
        this.currency = currency;
        return this;
    }

    getCurrency(currency) {
        return this.currency;
    }

    format(style = 'decimal', options = {}) {
        const locale = this.locale || I18nNumber.locale;
        const value = this.value || 0;

        return value.toLocaleString(locale, {
            style,
            ...options,
        });
    }
}

function i18nNumber(value) {
    return new I18nNumber(value);
}

export { I18nNumber };
export default i18nNumber;
